import {
  FETCH_USAGE_CONSUMPTION_REPORT_REQUEST,
  FETCH_USAGE_CONSUMPTION_REPORT_SUCCESS,
  FETCH_USAGE_CONSUMPTION_REPORT_ERROR,
  FETCH_USAGE_CONSUMPTION_STATUS_REQUEST,
  FETCH_USAGE_CONSUMPTION_STATUS_SUCCESS,
  FETCH_USAGE_CONSUMPTION_STATUS_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  error: null,
  isFetching: false,
  isSaving: false,
  list: [],
  statusList: [],
}

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_USAGE_CONSUMPTION_REPORT_REQUEST:
    case FETCH_USAGE_CONSUMPTION_STATUS_REQUEST:
      return {
        ...state,
        error: null,
        isFetching: true,
      }

    case FETCH_USAGE_CONSUMPTION_REPORT_SUCCESS:
      return {
        ...state,
        error: null,
        isFetching: false,
        list: action.payload,
      }

    case FETCH_USAGE_CONSUMPTION_REPORT_ERROR:
    case FETCH_USAGE_CONSUMPTION_STATUS_ERROR:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      }

    case FETCH_USAGE_CONSUMPTION_STATUS_SUCCESS:
      return {
        ...state,
        error: null,
        isFetching: false,
        statusList: action.payload,
      }

    default:
      return state
  }
}
